//@ts-nocheck
import {
  Box,
  Button,
  Drawer,
  Grid,
  TablePagination,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useQuery } from "react-query";
import { getAllResources } from "../../../api/services/api";
import {
  StyledDrawerContent,
  StyledDrawerHeader,
} from "../../../components/DrawerTemplate";
import EmptyScreen from "../../../components/EmptyScreen";
import Loader from "../../../components/Loader";
import ResourcesCard from "../../../components/ResourcesCard";
import VideosForm from "./VideosForm";

const Videos = () => {
  const [open, setOpen] = useState(false);
  const [videos, setVideos] = useState([]);
  const [formData, setFormData] = useState([]);
  const [limit, setLimit] = useState<number>(10);
  const [page, setPage] = useState<number>(0);

  const toggleDrawer = (newOpen: any) => {
    setOpen(newOpen);
  };

  const { data, isLoading } = useQuery(
    [
      "videos",
      {
        type: "VIDEO",
        limit: limit,
        offset: limit * page,
      },
    ],
    getAllResources,
    {
      onSuccess: (data) => {
        setVideos(data?.resources);
      },
    }
  );

  const handlePageChange = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleRowsPerPageChange = (event: any) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };
  if (isLoading) {
    return <Loader />;
  }

  return (
    <div>
      {" "}
      <Box
        sx={{
          marginBottom: "20px",
          pt: "20px",
        }}
      >
        <Box sx={{ display: "flex" }} gap={"26px"} alignItems="center">
          <Typography variant="h3">Videos</Typography>
          <Button
            onClick={() => {
              setFormData(null);
              toggleDrawer(true);
            }}
            variant="contained"
          >
            + Add Video
          </Button>
        </Box>
      </Box>
      {data?.data?.count === 0 ? (
        <EmptyScreen type={"videos"} />
      ) : (
        <>
          <Grid container spacing={3}>
            {data?.data?.resources?.map((item, index) => {
              return (
                <Grid item xs={4}>
                  <ResourcesCard
                    data={item}
                    video={item?.link}
                    thumbnail={item?.thumbnail}
                    date={item?.createdAt}
                    title={item?.title}
                    desc={item?.description}
                  />
                </Grid>
              );
            })}
          </Grid>
          <Box
            sx={{
              marginTop: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <TablePagination
              count={data?.data?.count || 0}
              page={page}
              onPageChange={handlePageChange}
              rowsPerPage={limit}
              onRowsPerPageChange={handleRowsPerPageChange}
            />
          </Box>
        </>
      )}
      <Drawer
        anchor="right"
        open={open}
        onClose={() => toggleDrawer(false)}
        onOpen={() => toggleDrawer(true)}
      >
        <StyledDrawerHeader>
          <Typography
            sx={{
              fontSize: "14px",
              fontFamily: "Inter_semibold",
              color: "black",
            }}
          >
            {formData ? "Edit Video" : "Add Video"}
          </Typography>
          <Typography
            sx={{
              fontSize: "15px",
              fontFamily: "Inter_semibold",
              color: "black",
              opacity: "0.5",
              cursor: "pointer",
            }}
            onClick={() => toggleDrawer(false)}
          >
            Cancel
          </Typography>
        </StyledDrawerHeader>
        <StyledDrawerContent>
          <Box sx={{ width: "550px" }}>
            <VideosForm data={formData} toggleDrawer={toggleDrawer} />
          </Box>
        </StyledDrawerContent>
      </Drawer>
    </div>
  );
};

export default Videos;
